import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";
const testimonialSlider = document.querySelector('#testimonial-slider')
if(testimonialSlider) {
  var testimonial_slider = tns({
    container: testimonialSlider,
    items: 1,
    autoplay: false,
    // nav: true,
    controlsContainer: '#testimonial-controls',
    prevButton: '#testimonial-previous',
    nextButton: '#testimonial-next',
    gutter:24,
    responsive: {
        767: {
          items: 2
        },
        1500: {
            items: 3
        }
      }
  });
}

const medicationsSlider = document.querySelector('#medications-slider')
if(medicationsSlider) {
  var medications_slider = tns({
    container: medicationsSlider,
    items: 1,
    slideBy: 1,
    autoplay: false,
    nav: false,
    controlsContainer: '#medications-controls',
    prevButton: '#medications-previous',
    nextButton: '#medications-next',
    gutter:24,
    responsive: {
        767: {
          items: 2
        },
        992: {
            items: 3
        },
        1200: {
          items: 4
        }
      }
  });
}
